const PHONE_NUMBER = process.env.REACT_APP_PHONE_NUMBER;
const BASE_SERVER_URL = process.env.REACT_APP_BASE_SERVER_URL;
const EMAIL = process.env.REACT_APP_EMAIL;
const TELE_USERNAME = process.env.REACT_APP_TELE_USERNAME;

export { PHONE_NUMBER, BASE_SERVER_URL, EMAIL, TELE_USERNAME };
